import { useTranslation } from 'next-i18next';
import {
  ReviewWrapper,
  ReviewWrapperAuhtor,
  ReviewWrapperDate,
  ReviewWrapperFooter,
  ReviewWrapperHeader,
  ReviewWrapperTitle,
} from './review.style';
import { dateFormat } from '../../helpers/dateHelper';
import React from 'react';
import RateStars from '../RateStars';
import colors from '../../theme/colors';
import icoCalendar from '@core/ui/static/images/ico-calendar.svg';
import { MdPerson, MdVerified } from 'react-icons/md';

const Review = ({
  id,
  title,
  message,
  rate,
  creatorAlternateName,
  creatorCertified,
  createdAt,
}) => {
  const { t } = useTranslation();

  return (
    <ReviewWrapper>
      <ReviewWrapperHeader>
        <ReviewWrapperTitle>
          <span>{title}</span>
        </ReviewWrapperTitle>
        <RateStars value={rate} readOnly />
      </ReviewWrapperHeader>
      <span>{message}</span>
      <ReviewWrapperFooter>
        <ReviewWrapperAuhtor>
          <MdPerson size={16} />
          {creatorAlternateName}
          {creatorCertified && (
            <MdVerified size={16} style={{ color: `${colors.primary}` }} />
          )}
        </ReviewWrapperAuhtor>
        <ReviewWrapperDate>
          <img
            src={icoCalendar}
            alt="Date de publication"
            style={{
              height: '13px',
            }}
          />
          {dateFormat(createdAt, t)}
        </ReviewWrapperDate>
      </ReviewWrapperFooter>
    </ReviewWrapper>
  );
};

export default Review;
